export const getSavedSearches = state =>
  state.mySavedSearchesReducer.savedSearches

export const getDeletingSearches = state =>
  state.mySavedSearchesReducer.deleting

export const getSavingSearches = state => state.mySavedSearchesReducer.saving
